import React from "react";
import "./PersonaCard.css";
import {
  formatDate3,
  PersonaExpanded,
  PersonaLinkRecordOrientation,
  truncateDisplayName,
} from "winslow-core";

export interface PersonaCardProps {
  persona: PersonaExpanded;
  onClick: (persona: PersonaExpanded) => void;
  showCloseButton?: boolean;
  onClose?: () => void;
}

export const PersonaCard: React.FC<PersonaCardProps> = ({
  persona,
  onClick,
  showCloseButton,
  onClose,
}) => {
  return (
    <div className="persona-card" onClick={() => onClick(persona)}>
      {showCloseButton && (
        <div
          className="persona-card-close"
          onClick={(e) => {
            e.stopPropagation();
            onClose?.();
          }}>
          <img src="/icons/close.png" alt="Remove filter" />
        </div>
      )}
      <div className="persona-card-user-info">
        Created By:
        <img
          loading="lazy"
          src={persona?.user?.avatarURL || "some backup"}
          className="persona-card-avatar"
          alt={`${persona.name} avatar`}
        />
        <div className="persona-card-user-name">
          {truncateDisplayName(
            `${persona?.user?.firstName || ""} ${persona?.user?.lastName || ""}`
          )}
        </div>
      </div>
      <div className="persona-card-content">
        <div className="persona-card-title">{persona.name}</div>
      </div>
      <div className="persona-card-statistics">
        <div className="persona-card-statistic">
          <div className="persona-card-statistic-label">Documents</div>
          <div className="persona-card-statistic-value">
            {
              persona.personaLinkRecords.filter(
                (plr) =>
                  plr.orientation === PersonaLinkRecordOrientation.INCLUSIONARY
              ).length
            }
          </div>
        </div>
        <div className="persona-card-statistic">
          <div className="persona-card-statistic-label">Last Updated</div>
          <div className="persona-card-statistic-value">
            {formatDate3(new Date(persona.updatedAt))}
          </div>
        </div>
      </div>
    </div>
  );
};
